import React, { useRef } from "react";
import { Editor } from "@tinymce/tinymce-react";
import styles from "./styles.module.scss";

const GreetingCardEditor = (props) => {
  const editorRef = useRef(null);
  const MAX_CHAR_LIMIT = props?.charLimit || 250;

  return (
    <div className={styles.wyiwig_editor_wrapper}>
      {/* <div>{props.label}</div> */}
      <Editor
        apiKey={process.env.REACT_APP_TINTINYMCE_KEY}
        initialValue={props.initialValue}
        onBlur={props.onBlur}
        onChange={props.onChange}
        onInit={props.onInit}
        {...props}
        init={{
          height: 200,
          placeholder: props?.placeholder,
          menubar: false,
          width: "100%",
          resize: false,
          statusbar: false,
          plugins: [
            "advlist autolink lists link image charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table paste code help wordcount image imagetools preview table",
          ],
          toolbar: `undo redo | bold italic underline backcolor forecolor |
          alignleft aligncenter alignright alignjustify | removeformat | help`,
          content_style:
            "body { font-family:Kern,sans-serif; font-size:14px; }",
          image_caption: true,

          paste_preprocess: (plugin, args) => {
            const currentText =
              editorRef.current?.getContent({ format: "text" }) || "";
            const pastedText = args.content.replace(/<[^>]+>/g, "");
            const totalLength = currentText.length + pastedText.length;

            if (totalLength > MAX_CHAR_LIMIT) {
              args.content = "";
              alert(`You can only enter up to ${MAX_CHAR_LIMIT} characters.`);
            }
          },
        }}
      />
    </div>
  );
};

export default GreetingCardEditor;
